import AxiosInitializer from 'api/Utility/AxiosInitializer'
import { getBaseURL } from 'lib/utility/GetBaseUrl'
import getToken from 'lib/authentication/GetToken'
import { handleStatus500 } from 'api/Utility/HandleStatus500'
import apiWrapper from 'api/Utility/ApiWrapper'

const axiosRequest = (extraParams: any = {}) => {
  const params = {
    token: getToken(),
    ...extraParams,
  }

  return AxiosInitializer({
    ...params,
  })
}

const importUsersEndPoints = {
  importUsers: (params: File) => {
    const fd = new FormData()
    fd.append('data[attributes[user_import_file[csv]]', params)
    const URL = `${getBaseURL()}/api/v2/participant_imports`

    return axiosRequest().post(URL, fd)
  },
}

const importUsersAPI = {
  importUsers: (params: File) =>
    apiWrapper({
      endPoint: importUsersEndPoints.importUsers,
      params,
      errorFailureAction: handleStatus500,
    }),
}

export default importUsersAPI
